<template>
    <div class="flex flex-col md:flex-row gap-6">
        <div class="flex flex-col gap-6">
            <h2 class="text-2xl md:text-4xl font-semibold">Patient Overview: Initial Presentation</h2>

            <div class="font-semibold">
                <h3 class="text-base md:text-2xl font-semibold mb-3">
                    A 40-year-old woman presented to the emergency department with a 2-week history of vomiting and
                    malaise, 1-week history of cold and painful blue toes, and 1-day history of chest pain
                </h3>

                <ul class="list-disc pl-4   font-light">
                    <li>
                        Two days prior, she was prescribed aspirin 81 mg orally daily for pain relief and referred to
                        vascular surgery for lower limb ischemia
                    </li>
                </ul>
            </div>

            <div class="font-semibold">
                <h3 class="text-base md:text-2xl font-semibold mb-3">Relevant medical history</h3>
                <div class="flex flex-col gap-3 font-normal">
                    <div class="p-5 text-white rounded bg-maroon">
                        Nephrolithiasis at age 19 years and 33 years, treated with lithotripsy
                    </div>
                    <div class="p-5 text-white rounded bg-purple">
                        Cold-induced pain and sensory deficits in the right ulnar distribution, with normal EMG and
                        brain MRI at age 26 years
                    </div>
                    <div class="p-5 text-white rounded bg-darkerblue">
                        Levonorgestrel and ethinyl estradiol 100-20 mcg orally daily for birth control
                    </div>
                </div>
            </div>

            <div class="font-semibold">
                <h3 class="text-base md:text-2xl font-semibold mb-3">Family history</h3>
                <ul class="list-disc pl-4   font-light">
                    <li>
                        No maternal family history of kidney disease or nephrolithiasis, and paternal family history was
                        unknown
                    </li>
                    <li>No siblings or children</li>
                </ul>
            </div>
        </div>

        <img src="@/assets/img/graphics/eskd/female-body-v2.svg" alt="Female body" :style="{ maxHeight: '780px' }" />
    </div>
</template>
